import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconLayerUp';
/** Renders an SVG icon. */
const SvgLayerUp = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path d="M19.707 7.293a1 1 0 1 1-1.414 1.414L17 7.414V21a1 1 0 1 1-2 0V7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0z" />
      <path d="M26 22H6v2h20zM6 26a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm0-14h6a1 1 0 1 1 0 2H6v2h6a1 1 0 1 1 0 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2m14 4h6v-2h-6a1 1 0 1 1 0-2h6a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-6a1 1 0 1 1 0-2" />
    </svg>
  );
};
SvgLayerUp.displayName = displayName;
export default SvgLayerUp;
